class WalletService {
  constructor(apiClient) {
    this.client = apiClient;
  }

  async createAppleWalletPass(ticketId) {
    return await this.client.get(`applewalletpass/createpass/${ticketId}`, {
      responseType: 'blob'
    });
  }
  
  async createGoogleWalletPass(identifier) {
    return await this.client.get(`googlewalletpass/createpasslink`,
      { params: { identifier } }
    );
  }
}

export default WalletService;